import {
  initialState,
  Actions,
  State,
  GET_ONE_ENROLLMENT,
  GET_ONE_ENROLLMENT_SUCCESS,
  GET_ONE_ENROLLMENT_ERROR,
  RESET_GET_ONE_ENROLLMENT,
} from '../../types/enrollment/get-one.dto';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_ENROLLMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case GET_ONE_ENROLLMENT_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case GET_ONE_ENROLLMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_GET_ONE_ENROLLMENT:
      return { ...initialState };
    default:
      return { ...state };
  }
};

export default reducers;
